
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iw0vE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $ca6ccc9d5a51f797$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Chinese (Traditional)
var $ca6ccc9d5a51f797$export$2e2bcd8739ae039 = {
    "'Goals.CreateGoal.footer.create-label": "\u5EFA\u7ACB",
    'Goals.CreateGoal.EditMetric.header': "\u7DE8\u8F2F\u6307\u6A19",
    'Goals.CreateGoal.create.error': "\u7121\u6CD5\u5EFA\u7ACB\u76EE\u6A19",
    'Goals.CreateGoal.create.network.error': "\u9023\u7DDA\u5931\u6557",
    'Goals.CreateGoal.create.permission.error': "\u60A8\u6C92\u6709\u5EFA\u7ACB\u76EE\u6A19\u6240\u9700\u7684\u6B0A\u9650\u3002",
    'Goals.CreateGoal.error.description': "\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u60A8\u7684\u7DB2\u969B\u7DB2\u8DEF\u9023\u7DDA\u4E26\u518D\u8A66\u4E00\u6B21\u3002",
    'Goals.CreateGoal.error.header': "\u7121\u6CD5\u5EFA\u7ACB\u76EE\u6A19",
    'Goals.CreateGoal.footer.cancel-label': "\u53D6\u6D88",
    'Goals.CreateGoal.form.icon.back-button-label': "\u8FD4\u56DE",
    'Goals.CreateGoal.form.name.error': "\u4F60\u5FC5\u9808\u63D0\u4F9B\u76EE\u6A19\u540D\u7A31",
    'Goals.CreateGoal.form.name.label': "\u540D\u7A31",
    'Goals.CreateGoal.form.owner.error': "\u8CA0\u8CAC\u4EBA\u4E0D\u80FD\u7A7A\u767D\u3002",
    'Goals.CreateGoal.header': "\u5EFA\u7ACB\u76EE\u6A19",
    'Goals.CreateGoal.parent-goal-label': "\u7236\u7CFB\u76EE\u6A19",
    'Goals.CreateGoal.parent-goal.error': "\u7236\u7CFB\u76EE\u6A19\u4E0D\u80FD\u7A7A\u767D\u3002",
    'Goals.CreateGoal.required-fields-are-marked': "\u5FC5\u586B\u6B04\u4F4D\u6A19\u6709\u661F\u865F <asterisk></asterisk>",
    'Goals.CreateGoal.site-label': "\u7DB2\u7AD9",
    'Goals.CreateGoal.type-label': "\u985E\u578B",
    'Goals.CreateGoal.type-label-placeholder': "\u8981\u53D6\u4EC0\u9EBC\u540D\u7A31\uFF1F",
    'Goals.CreateMetric.add-metric-button': "\u65B0\u589E\u6307\u6A19",
    'Goals.CreateMetric.metric-select.create-new': "\u5EFA\u7ACB\u65B0\u6307\u6A19",
    'Goals.CreateMetric.metric-select.use-existing': "\u4F7F\u7528\u73FE\u6709\u6307\u6A19",
    'Goals.CreateMetric.metric-start-value.label': "\u958B\u59CB\u503C",
    'Goals.CreateMetric.metric-target-value.label': "\u76EE\u6A19\u503C",
    'Goals.CreateMetric.metric-unit-select.label': "\u55AE\u4F4D",
    'Goals.GoalCreationModal.label.date-selection-placeholder': "\u9078\u53D6\u65E5\u671F",
    'Goals.GoalCreationModal.label.date-selection-title': "\u76EE\u6A19\u65E5\u671F",
    'Goals.GoalCreationModal.label.owner-picker-placeholder': "\u8F38\u5165\u4EBA\u54E1",
    'Goals.GoalCreationModal.label.owner-selection-title': "\u8CA0\u8CAC\u4EBA",
    'townsquare.api.goal-type-description.goal': "\u4EFB\u4F55\u76EE\u6A19",
    'townsquare.api.goal-type-description.key-result': "\u8861\u91CF\u76EE\u7684\u7684\u91CF\u6027\u65B9\u6CD5 (\u76EE\u6A19\u8207\u95DC\u9375\u6210\u679C (OKR) \u67B6\u69CB)\u3002",
    'townsquare.api.goal-type-description.objective': "\u60A8\u60F3\u8981\u5BE6\u73FE\u7684\u7D50\u679C (\u76EE\u6A19\u8207\u95DC\u9375\u6210\u679C (OKR) \u67B6\u69CB)\u3002"
};

});


//# sourceMappingURL=zh_TW.52e41400.js.map
